// Here we get all the parameters in the appSettings

import { AppConfiguration } from "read-appsettings-json";

export const encryptKey = AppConfiguration.Setting().encryptKey;

export const encryptKeyPassword = AppConfiguration.Setting().encryptKeyPassword;